// extracted by mini-css-extract-plugin
export default {"navbar":"styles_navbar__Eiouc","logo":"styles_logo__XJMgc","controls":"styles_controls__ztn6m","getStartedButton":"styles_getStartedButton__G1MEU","light":"styles_light__VW9Zm"};